import { useWindowDimensions } from 'hooks/UseWindowDimensions'
import Breakpoints from 'utils/breakpoints.module.scss'

export function responsiveDesignLogic(width = window.innerWidth) {
  const phoneSmallMaxWidth = parseInt(Breakpoints.phoneSmallMaxWidth)
  const phoneMediumMinWidth = parseInt(Breakpoints.tabletPortraitMinWidth)
  const phoneMediumMaxWidth = parseInt(Breakpoints.phoneMediumMaxWidth)
  const phoneMaxWidth = parseInt(Breakpoints.phoneMaxWidth)
  const tabletPortraitMaxWidth = parseInt(Breakpoints.tabletPortraitMaxWidth)
  const tabletLandscapeMaxWidth = parseInt(Breakpoints.tabletLandscapeMaxWidth)
  const desktopMinWidth = parseInt(Breakpoints.desktopMinWidth)
  const bigDesktopMinWidth = parseInt(Breakpoints.bigDesktopMinWidth)
  const inch13Width = parseInt(Breakpoints.inch13Width)
  const inch15Width = parseInt(Breakpoints.inch15Width)

  const isMobileSm = width <= phoneSmallMaxWidth
  const isMobileLg = width <= phoneMediumMinWidth
  const isMobileMd = width <= phoneMediumMaxWidth
  const isMobile = width <= phoneMaxWidth
  const isTabletPortrait = width <= tabletPortraitMaxWidth
  const isTabletLandscape = width <= tabletLandscapeMaxWidth
  const isDesktop = width >= desktopMinWidth
  const isBigDesktop = width >= bigDesktopMinWidth
  const isInch13Width = width >= inch13Width
  const isInch15Width = width >= inch15Width
  const isIOSNative = navigator.userAgent.includes('blaze-ios')

  return {
    isMobileSm,
    isMobile,
    isMobileMd,
    isMobileLg,
    isTabletPortrait,
    isTabletLandscape,
    isDesktop,
    isBigDesktop,
    isInch13Width,
    isInch15Width,
    viewPortWidth: width,
    isIOSNative,
  }
}

const useResponsiveDesign = () => {
  const { width } = useWindowDimensions()
  return responsiveDesignLogic(width)
}

export default useResponsiveDesign
